<template>
  <div></div>
</template>

<script>
import store from '../store/store'
import {ebus} from "../vendor/ebus";
import * as bootstrap from "../vendor/bootstrap";
import axios from "axios";

const stableAxios = axios.create()

export default {
  name: "KioskLifecycle",
  data() {
    return {}
  },
  created() {
    ebus.$on('postToWindowskiosk', (params) => {
      console.log('KioskLifecycle emit received postToWindowskiosk');
      this.$nextTick(() => {
        this.postToWindowskiosk(params);
      });
    });
  },
  mounted() {
    if (store.getters.isKiosk) {
      this.init();
    }
  },
  methods: {
    init() {

    },
    async postToWindowskiosk(params) {
      if (!store.getters.isKiosk) {
        console.log('KioskLifecycle postToWindowskiosk isKiosk=false');
        return;
      }

      const action = params.action;
      console.log('KioskLifecycle going to post postToWindowskiosk for action ' + action);

      params.terminalId = '1';
      let timeout = 3000;
      if (action === 'checkTerminalServiceActive') {
        timeout = 2000;
      } else if (action === 'triggerPosTerminal') {
        timeout = 1000 * (120 + 180);
      }

      await this.post(params, (reply) => {
        reply.action = action
        if (reply.ok) {
          console.log('KioskLifecycle postToWindowskiosk was ok');
        } else {
          console.log('KioskLifecycle error: postToWindowskiosk was notok');
        }
        ebus.$emit(params.cb, reply);
      }, (err) => {
        console.log('KioskLifecycle error in postToWindowskiosk: ' + err);
        ebus.$emit(params.cb, {ok: false, error: err, action: action});
      }, timeout);
    },

    async post(message, callback, error, timeoutOverride) {
      if (!message) {
        return;
      }

      // const baseURL = 'https://qdev.de:8088/';
      const baseURL = 'https://localhost:8088/';
      const endpoint = baseURL + 'v1/kiosk/postHandler';

      message.btaste = bootstrap.getBtaste();

      console.log('KioskLifecycle >>>>>>>>>> POST ', message);

      let timeout = 10000;
      if (timeoutOverride) {
        timeout = timeoutOverride;
      }
      message.timeout = timeout;

      message['Kiosk-Authorization'] = 'pVr0oSIvUGUX9jI8S9ZtmT';

      try {
        try {
          console.log('KioskLifecycle going to post message to ' + endpoint + ' for action: ' + message.action);
          stableAxios
            .post(endpoint, message, {
              headers: {
                'Content-Type': 'application/json',
              }, timeout: timeout
            })
            .then((reply) => {
              // console.log('KioskLifecycle <<< Reply ', reply);
              // console.log('KioskLifecycle <<< Reply :' + JSON.stringify(reply));
              if (reply && reply.data) {
                callback(reply.data);
              } else {
                console.log('KioskLifecycle response not ok');
                error();
              }
            }).catch((err) => {
            // error callback
            console.log('KioskLifecycle Catched error: ', err);
            if (error) {
              error(err);
            }
          });
        } catch (sendError) {
          console.log('KioskLifecycle sendException: ' + sendError);
          error(sendError);
        }
      } catch (outerErr) {
        console.log('KioskLifecycle Unexpected error', outerErr);
        if (error) {
          error(outerErr);
        }
      }
    }
  }// eof methods
}
</script>


